function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/* GENERATED FILE - DO NOT MODIFY
 * Generated for TR Onvio Document Services API using Universal-Swaggergen
 *
 * See generated.json for more information
 */

/* eslint-disable */

import GeneratedService from '../GeneratedService';
export var batchAddFoldersAndLinkedDocumentsPath = function batchAddFoldersAndLinkedDocumentsPath(containerType, containerId) {
  return "/api/storage/v1/".concat(containerType, "/").concat(containerId, "/batch");
};
export var getChildrenPath = function getChildrenPath(containerType, id) {
  return "/api/storage/v2/".concat(containerType, "/").concat(id, "/children");
};
export var getContainerWithDescendantsPath = function getContainerWithDescendantsPath(containerType, id) {
  return "/api/storage/v1/".concat(containerType, "/").concat(id, "/descendants");
};
export var batchDeletePath = function batchDeletePath() {
  return "/api/storage/v1/batch-delete";
};
export var getClientsPath = function getClientsPath() {
  return "/api/storage/v1/clients";
};
export var getPath = function getPath() {
  return "/api/storage/v1/containers";
};
export var findOrCreateFolderPathPath = function findOrCreateFolderPathPath(containerType, containerId) {
  return "/api/storage/v1/containers/".concat(containerType, "/").concat(containerId, "/find-create-path");
};
export var getAllDocumentsPath = function getAllDocumentsPath() {
  return "/api/storage/v1/containers/documents";
};
export var getAllDocumentsCountPath = function getAllDocumentsCountPath() {
  return "/api/storage/v1/containers/documents/count";
};
export var getSearchDocumentsAsyncPath = function getSearchDocumentsAsyncPath() {
  return "/api/storage/v1/containers/documents/search";
};
export var getFirmDocumentsFolderPath = function getFirmDocumentsFolderPath() {
  return "/api/storage/v1/containers/firm-folder";
};
export var getTreePath = function getTreePath() {
  return "/api/storage/v1/containers/tree";
};
var Containers = /*#__PURE__*/function (_GeneratedService) {
  function Containers() {
    _classCallCheck(this, Containers);
    return _callSuper(this, Containers, arguments);
  }
  _inherits(Containers, _GeneratedService);
  return _createClass(Containers, [{
    key: "batchAddFoldersAndLinkedDocuments",
    value: (
    /**
     * **Creates Folders and Linked Documents from JSON tree**
     *
     * Files or physical documents with content/binaries (i.e PDFs, Word Documents, etc.) will not work
     *
     * only Linked Documents and Folders are allowed for now.
     *
     * Example: POST api/storage/v1/folders/yD4FRkbEtzkyJfgKlhQTVIZC3xg_0B9W/batch
     */
    function () {
      var _batchAddFoldersAndLinkedDocuments = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(containerType, containerId, batchAddObject, customData) {
        var config;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              config = {
                method: 'POST',
                url: batchAddFoldersAndLinkedDocumentsPath(containerType, containerId),
                body: JSON.stringify(batchAddObject),
                customData: customData
              };
              return _context.abrupt("return", this.callHttp(config, true));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function batchAddFoldersAndLinkedDocuments(_x, _x2, _x3, _x4) {
        return _batchAddFoldersAndLinkedDocuments.apply(this, arguments);
      }
      return batchAddFoldersAndLinkedDocuments;
    }()
    /**
     * **Gets children (folders and documents) for a given container**
     *
     * See documentation of Get storage/{version}/folders/{id} for returned folders DTO.
     *
     * See documentation of Get storage/{version}/{containerType}/{containerId}/documents/{id}/metadata for returned Documents DTO.
     *
     * Note: Use ItemType to determine the type of child being returned. Possible values: Project, Folder, Document
     */
    )
  }, {
    key: "getChildren",
    value: (function () {
      var _getChildren = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(containerType, id, params, customData) {
        var config;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              config = {
                method: 'GET',
                url: getChildrenPath(containerType, id),
                params: this.queryParamsToStringMap(params),
                customData: customData
              };
              return _context2.abrupt("return", this.callHttp(config, true));
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getChildren(_x5, _x6, _x7, _x8) {
        return _getChildren.apply(this, arguments);
      }
      return getChildren;
    }()
    /**
     * **Get container (project or folder) and all descendants**
     */
    )
  }, {
    key: "getContainerWithDescendants",
    value: (function () {
      var _getContainerWithDescendants = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(containerType, id, customData) {
        var config;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              config = {
                method: 'GET',
                url: getContainerWithDescendantsPath(containerType, id),
                customData: customData
              };
              return _context3.abrupt("return", this.callHttp(config, true));
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getContainerWithDescendants(_x9, _x10, _x11) {
        return _getContainerWithDescendants.apply(this, arguments);
      }
      return getContainerWithDescendants;
    }()
    /**
     * **Deletes folders, documents, or projects from given list**
     *
     * Provided a list of folders/projects/documents, they can be deleted from any level of the tree.This endpoint can delete physical and link documents.The HTTP method had to be PUT as opposed to DELETE because Zuul currently doesn't allow passing a body in the request.Example: PUT api/storage/v1/batch-delete
     */
    )
  }, {
    key: "batchDelete",
    value: (function () {
      var _batchDelete = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(deleteBatch, customData) {
        var config;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              config = {
                method: 'PUT',
                url: batchDeletePath(),
                body: JSON.stringify(deleteBatch),
                customData: customData
              };
              return _context4.abrupt("return", this.callHttp(config, false));
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function batchDelete(_x12, _x13) {
        return _batchDelete.apply(this, arguments);
      }
      return batchDelete;
    }()
    /**
     * **Get clients for a company.**
     */
    )
  }, {
    key: "getClients",
    value: (function () {
      var _getClients = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(params, customData) {
        var config;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              config = {
                method: 'GET',
                url: getClientsPath(),
                params: this.queryParamsToStringMap(params),
                customData: customData
              };
              return _context5.abrupt("return", this.callHttp(config, true));
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getClients(_x14, _x15) {
        return _getClients.apply(this, arguments);
      }
      return getClients;
    }()
    /**
     * **Get parent containers for given itemIds or root containers (projects and folders), if no itemIds are given**
     */
    )
  }, {
    key: "get",
    value: (function () {
      var _get = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(params, customData) {
        var config;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              config = {
                method: 'GET',
                url: getPath(),
                params: this.queryParamsToStringMap(params),
                customData: customData
              };
              return _context6.abrupt("return", this.callHttp(config, true));
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function get(_x16, _x17) {
        return _get.apply(this, arguments);
      }
      return get;
    }()
    /**
     * **Finds and creates a path of folders provided as a flat list**
     *
     * If one of the folders in the path already exists then the next subfolder will be assessed along the provided path
     */
    )
  }, {
    key: "findOrCreateFolderPath",
    value: (function () {
      var _findOrCreateFolderPath = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(containerType, containerId, findAndCreate, customData) {
        var config;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              config = {
                method: 'POST',
                url: findOrCreateFolderPathPath(containerType, containerId),
                body: JSON.stringify(findAndCreate),
                customData: customData
              };
              return _context7.abrupt("return", this.callHttp(config, true));
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function findOrCreateFolderPath(_x18, _x19, _x20, _x21) {
        return _findOrCreateFolderPath.apply(this, arguments);
      }
      return findOrCreateFolderPath;
    }()
    /**
     * **Returns a flat list of files a user has access applying filter parameters**
     *
     * To filter documents with "createdDate" starting 2018-10-23: "createdDate=2018-10-23T0Z/P99Y"
     *
     * CustomFields available to filter:
     *
     * "dueDate", date type, ex: [{"Name":"dueDate","Value":"2018-10-23T0Z/P99Y"}]
     *
     * Date filtering reference: https://git.sami.int.thomsonreuters.com/akkadia/wikakkadia/wikis/date%20filtering
     */
    )
  }, {
    key: "getAllDocuments",
    value: (function () {
      var _getAllDocuments = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(params, customData) {
        var config;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              config = {
                method: 'GET',
                url: getAllDocumentsPath(),
                params: this.queryParamsToStringMap(params),
                customData: customData
              };
              return _context8.abrupt("return", this.callHttp(config, true));
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function getAllDocuments(_x22, _x23) {
        return _getAllDocuments.apply(this, arguments);
      }
      return getAllDocuments;
    }()
    /**
     * **Returns the total of files a user has access applying filter parameters**
     *
     * To filter documents with "createdDate" starting 2018-10-23: "createdDate=2018-10-23T0Z/P99Y"
     *
     * CustomFields available to filter:
     *
     * "dueDate", date type, ex: [{"Name":"dueDate","Value":"2018-10-23T0Z/P99Y"}]
     *
     * Date filtering reference: https://git.sami.int.thomsonreuters.com/akkadia/wikakkadia/wikis/date%20filtering
     */
    )
  }, {
    key: "getAllDocumentsCount",
    value: (function () {
      var _getAllDocumentsCount = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(params, customData) {
        var config;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              config = {
                method: 'GET',
                url: getAllDocumentsCountPath(),
                params: this.queryParamsToStringMap(params),
                customData: customData
              };
              return _context9.abrupt("return", this.callHttp(config, true));
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function getAllDocumentsCount(_x24, _x25) {
        return _getAllDocumentsCount.apply(this, arguments);
      }
      return getAllDocumentsCount;
    }()
    /**
     * **Returns a flat list of files a user has access to from all containers using elastic search**
     */
    )
  }, {
    key: "getSearchDocumentsAsync",
    value: (function () {
      var _getSearchDocumentsAsync = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(params, customData) {
        var config;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              config = {
                method: 'GET',
                url: getSearchDocumentsAsyncPath(),
                params: this.queryParamsToStringMap(params),
                customData: customData
              };
              return _context10.abrupt("return", this.callHttp(config, true));
            case 2:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function getSearchDocumentsAsync(_x26, _x27) {
        return _getSearchDocumentsAsync.apply(this, arguments);
      }
      return getSearchDocumentsAsync;
    }()
    /**
     * **Returns a firm's "Firm Documents" folder.**
     */
    )
  }, {
    key: "getFirmDocumentsFolder",
    value: (function () {
      var _getFirmDocumentsFolder = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11(customData) {
        var config;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              config = {
                method: 'GET',
                url: getFirmDocumentsFolderPath(),
                customData: customData
              };
              return _context11.abrupt("return", this.callHttp(config, true));
            case 2:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function getFirmDocumentsFolder(_x28) {
        return _getFirmDocumentsFolder.apply(this, arguments);
      }
      return getFirmDocumentsFolder;
    }()
    /**
     * **Returns all root items, along with descendant folders the current user has access to.  By default, orphan folders are not returned, but can**
     * **be included by providing the optional query parameter.**
     */
    )
  }, {
    key: "getTree",
    value: (function () {
      var _getTree = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12(params, customData) {
        var config;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              config = {
                method: 'GET',
                url: getTreePath(),
                params: this.queryParamsToStringMap(params),
                customData: customData
              };
              return _context12.abrupt("return", this.callHttp(config, true));
            case 2:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function getTree(_x29, _x30) {
        return _getTree.apply(this, arguments);
      }
      return getTree;
    }())
  }]);
}(GeneratedService);
export { Containers as default };
